import { formatFiltersForApi } from '../../utils/filterUtils';

const initiationSearchKeysDict = {
    account: 'Client',
    customer: 'Customer Number',
    clinician: 'Clinician',
    booking: 'Booking Number',
    collector: 'Collector',
    po: 'PO Number',
};

const managementSearchKeysDict = {
    account: 'Client',
    customer: 'Customer Number',
    bookingid: 'Booking Number',
    clinicianname: 'Clinician',
    invoicenumber: 'Invoice Number',
    collectorname: 'Collector',
    ponumber: 'PO Number',
};

export const initiationSearchOptions = Object.entries(initiationSearchKeysDict).map(
    ([key, name]) => ({ name, value: key })
);

export const managementSearchOptions = Object.entries(managementSearchKeysDict).map(
    ([key, name]) => ({ name, value: key })
);

export const isBookingSelectable = (b) => ['PreInvoiced'].includes(b?.status);

export const generateIdForExpenseWrapper = (ids = []) => ids?.sort((a, b) => a - b)?.join('');

export const wrapExpenseItems = (booking) => ({
    ...booking,
    expenses:
        booking?.expenses?.items?.length > 0 // filter out expenses with no items
            ? [
                  {
                      id: generateIdForExpenseWrapper(
                          booking.expenses.items?.map((item) => item.id)
                      ), // generate id for expense items wrapped based on expenses items ids
                      ...booking.expenses,
                  },
              ]
            : [],
});

export const formatFiltersForManagementApi = (filtersValues, filtersSetup) => {
    const statusOverridesForApiDict = {
        PreInvoiced: 'Invoiced',
        Error: 'Errored',
    };

    const mapList = (arr, dict) => arr?.map((x) => (dict[x] ? dict[x] : x))?.filter(Boolean);

    const mappedFilters = {
        ...(filtersValues ?? {}),
        invoiceStatus: mapList(filtersValues?.invoiceStatus, statusOverridesForApiDict),
    };

    return formatFiltersForApi(mappedFilters, filtersSetup);
};
